import React, { useRef } from 'react'
import GalleryPhoto from '../components/GalleryPhoto'

export default function useGalleryComponent(gallery: Customer.Models.Gallery) {
    const { current: component } = useRef((props: ArchiveComponentProps<Interfaces.Photo.Includes<"acceptances_count" | "awards_count" | "salons_count">>) => {
        return <GalleryPhoto data={props.data} gallery={gallery} />
    })

    return component
}